import React from "react";
import {
  Datagrid,
  TextField,
  ReferenceField,
  Show,
  RichTextField,
  DateField,
  SimpleShowLayout,
  useRecordContext,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";

const TransferOrderShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="subject" />
        <ReferenceField
          label="User Name"
          source="userId"
          reference="users"
          resource="users"
        >
          <TextField source="firstName" />
          <TextField source="lastName" />
        </ReferenceField>
        <DateField label="Creation date" source="createdAt" />
      </SimpleShowLayout>
    </Show>
  );
};

export default TransferOrderShow;
